module.exports = __webpack_public_path__ + "static/media/icon.b0009f25.svg";